export default "__VITE_ASSET__CJLe86Ui__"